import styled from 'styled-components';
import { ModalBody, ModalBodyProps } from './ModalBody';
import { colors } from '@ardoq/design-tokens';

const ModalBodyWrapper = styled.div`
  flex: 1;
  display: flex;
  overflow: hidden;
  background-color: ${colors.surfaceDefault};
`;

const ModalWrapper = ({ children }: ModalBodyProps) => (
  <ModalBodyWrapper>
    <ModalBody>{children}</ModalBody>
  </ModalBodyWrapper>
);

export { ModalWrapper };
